import React from 'react';
import '../components/company/company.css';
import Companyhistory from '../components/company/history';

function History() {

  return (
    <div className='newAdmin'>   
      <div className="companies">
      <Companyhistory/>
      </div>
    </div>
  )
}

export default History;
